import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';

import './ww-element.scss';
import { StaticImage } from 'gatsby-plugin-image';

interface IProps {
  weapon: string;
}

export const WWWeapon: React.FC<IProps> = ({ weapon }) => {
  const popoverElement = (
    <Popover id="popover-element">
      <Popover.Header as="h3">{weapon}</Popover.Header>
      <Popover.Body>This character weapon is {weapon}</Popover.Body>
    </Popover>
  );
  return (
    <OverlayTrigger
      trigger="click"
      rootClose
      placement="auto-start"
      overlay={popoverElement}
    >
      <div className={`ww-weapon ${weapon}`}>
        {weapon === 'Broadblade' && (
          <>
            <StaticImage
              src="../../../../images/ww/icons/weapon_broadblade.png"
              alt={weapon}
            />
          </>
        )}
        {weapon === 'Sword' && (
          <>
            <StaticImage
              src="../../../../images/ww/icons/weapon_sword.png"
              alt={weapon}
            />
          </>
        )}
        {weapon === 'Pistols' && (
          <>
            <StaticImage
              src="../../../../images/ww/icons/weapon_pistols.png"
              alt={weapon}
            />
          </>
        )}
        {weapon === 'Rectifier' && (
          <>
            <StaticImage
              src="../../../../images/ww/icons/weapon_rectifier.png"
              alt={weapon}
            />
          </>
        )}
        {weapon === 'Gauntlets' && (
          <>
            <StaticImage
              src="../../../../images/ww/icons/weapon_gauntlets.png"
              alt={weapon}
            />
          </>
        )}
        {weapon}
      </div>
    </OverlayTrigger>
  );
};
